module.exports = __webpack_public_path__ + "static/media/photo-proof.e4eaca6f.png";